import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { PageHeader, Panel } from "@/components/app/common";
import { useFetch } from "@/hooks/useFetch";
import { api, errMsg } from "@/lib/api";

const CO = [["reg_name", "Registered company name"], ["gstin", "GSTIN"], ["reg_address", "Registered address", true], ["state_name", "State name"], ["state_code", "State code"],
  ["pan", "PAN"], ["cin", "CIN (optional)"], ["msme_no", "MSME / Udyam no."], ["msme_category", "MSME category"], ["signatory_name", "Authorised signatory name"],
  ["pi_prefix", "Proforma number prefix"], ["pi_declaration", "Proforma declaration", true]];

// Quotation settings (admin only). The PDF always uses the TESSOL virtual letterhead.
export default function SalesLetterhead() {
  const { data, setData } = useFetch("/sales/letterhead");
  const [f, setF] = useState({});
  useEffect(() => { if (data) setF(data); }, [data]);
  const save = async () => {
    try { const r = await api.put("/sales/letterhead", { ...Object.fromEntries(CO.map(([k]) => [k, f[k] ?? ""])), sales_inbox: f.sales_inbox || "", bank_details: f.bank_details || "", footer_note: f.footer_note || "" }); setData(r.data); const a = r.data.bank_alert; toast.success(a ? `Saved · bank details alert ${a.status.replace(/_/g, " ")}${a.to?.length ? ` to ${a.to.length} admin(s)` : ""}` : "Saved"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="sales-letterhead-page">
      <PageHeader title="Quotation settings" subtitle="All quotation PDFs are printed on the TESSOL virtual letterhead (logo, address and footer come from it)." />
      <Panel title="Email and PDF extras">
        <div className="grid grid-cols-1 gap-3 max-w-2xl">
          <div><Label>Shared sales inbox (copied on every quotation email)</Label><Input value={f.sales_inbox || ""} onChange={(e) => setF({ ...f, sales_inbox: e.target.value })} data-testid="letterhead-sales_inbox" /></div>
          <div><Label>Bank details (printed below the terms, optional)</Label><Textarea rows={3} value={f.bank_details || ""} onChange={(e) => setF({ ...f, bank_details: e.target.value })} data-testid="letterhead-bank_details" /></div>
          <div><Label>Footer note next to the quote number (optional)</Label><Input value={f.footer_note || ""} onChange={(e) => setF({ ...f, footer_note: e.target.value })} data-testid="letterhead-footer_note" /></div>
          <div><Button onClick={save} data-testid="letterhead-save-btn">Save</Button></div>
        </div>
      </Panel>
      <Panel title="Company details for proforma invoices" testid="letterhead-company-panel">
        <p className="mb-2 text-xs text-slate-500">Printed on proforma invoices. GSTIN, state code, address, PAN and signatory name are needed before a proforma can be issued. Bank details above are reused.</p>
        <div className="grid max-w-3xl grid-cols-1 gap-3 md:grid-cols-2">
          {CO.map(([k, l, multi]) => <div key={k} className={multi ? "md:col-span-2" : ""}><Label>{l}</Label>{multi ? <Textarea rows={3} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`letterhead-${k}`} />
            : <Input value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`letterhead-${k}`} />}</div>)}
          <div><Button onClick={save} data-testid="letterhead-company-save-btn">Save</Button></div>
        </div>
      </Panel>
    </div>
  );
}
